import React, {createContext, useEffect, useState} from "react";
import {strings} from "../strings/strings";

interface IProcessingContextProps {
    isProcessingOpen: boolean,
    setProcessingOpen: (isOpen: boolean) => void,
    processingTitle: string,
    setProcessingTitle: (title: string) => void,
    processingText: string,
    setProcessingText: (text: string) => void
}

const defaultContext: IProcessingContextProps = {
    isProcessingOpen: false,
    setProcessingOpen: () => {
    },
    setProcessingTitle: () => {
    },
    setProcessingText: () => {
    },
    processingTitle: '',
    processingText: '',
}

export const ProcessingContext = createContext(defaultContext);

const ProcessingContextProvider: React.FC = ({children}) => {
    const [isProcessingOpen, setProcessingOpen] = useState<boolean>(false);
    const [processingTitle, setProcessingTitle] = useState<string>(strings.processingDialogTitle);
    const [processingText, setProcessingText] = useState<string>(strings.processingDialogText2);

    useEffect(() => {
        //default values
        if (!isProcessingOpen) {
            setProcessingTitle(strings.processingDialogTitle);
            setProcessingText(strings.processingDialogText2);
        }
    }, [isProcessingOpen])

    return <ProcessingContext.Provider value={{
        isProcessingOpen, setProcessingOpen,
        processingTitle, setProcessingTitle,
        processingText, setProcessingText
    }}>
        {children}
    </ProcessingContext.Provider>
}

export default ProcessingContextProvider;